<template>
  <div>
    <v-card-text class="pt-0 mt-0">
      <v-chip class="mt-4" label color="transparent" text-color="black">
        <h3>Seleccionar Profesional</h3>
      </v-chip>
    </v-card-text>
    <div class="cointainer">
      <v-row v-if="profesionales.length" class="ml-2 mr-1 mb-4">
        <v-col cols="12" md="3" sm="4">
          <v-select
            :items="servicios"
            item-text="especialidad"
            item-value="servicio"
            menu-props="auto"
            label="Especialidad"
            hide-details
            v-model="servicio"
            @change="filtrarProfesionales"
            class="mt-6"
            ref="servicio"
            no-data-text="No hay especialidades configuradas"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="profesionales.length" class="mx-4 profesionales-row">
        <div
          v-for="item in profesionales"
          :key="item.idProfesional"
          class="col-sm-4 col-md-3 card"
          style="border: 0.1px solid grey; margin: 10px"
          @click="seleccionar(item)"
        >
          <div class="panel panel-success">
            <div class="panel-heading text-center">
              <v-img
                class="img center mb-3"
                max-height="150px"
                max-width="150px"
                alt="Sin Foto"
                :aspect-ratio="1"
                :src="item.foto"
                position="top"
              ></v-img>

              <h2 class="panel-title">
                {{ item.nombre }}
              </h2>
            </div>
            <div class="panel-body text-center mt-1">
              <h4>Especialidad: {{ item.especialidad }}</h4>
              <h4
                class="mt-1"
                style="color: red !important"
                v-if="
                  item.observaciones != '' &&
                  item.observaciones != null &&
                  idInstitucion !== 436
                "
              >
                Observaciones: {{ item.observaciones }}
              </h4>
              <h4
                class="mt-1"
                style="color: red !important"
                v-if="item.precioConsultaString"
              >
                Valor: {{ item.precioConsultaString }}
              </h4>
              <h4
                v-if="
                  item.observaciones == '' &&
                  item.observaciones == null &&
                  !item.precioConsultaString
                "
              >
                <br />
              </h4>
              <!-- <v-btn small class="success mt-2" @click="seleccionar(item)"
                >Seleccionar</v-btn
              > -->
            </div>
          </div>
        </div>
      </v-row>
      <v-alert color="blue" dark outlined v-else class="mb-0 mt-2"
        >No hay profesionales con turnos disponibles, comuníquese directamente
        con la institución</v-alert
      >
    </div>
  </div>
</template>
<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.img {
  border: 0.5px solid black;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border: 0px !important;
  cursor: pointer;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  background-color: rgb(210, 223, 228);
  transform: scale(1.05);
}
.profesionales-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* padding-left: 8rem;
  padding-right: 8rem; */
}
</style>
<script>
export default {
  props: ["listaProfesionales", "idInstitucion"],
  data: (vm) => ({
    servicios: [],
    servicio: 1,
    profesionales: [],
  }),
  watch: {
    listaProfesionales: {
      handler(val) {
        if (val.length) {
          const servicios = Object.values(
            val.reduce((acc, prof) => {
              if (!acc[prof.servicio]) {
                acc[prof.servicio] = {
                  servicio: prof.servicio,
                  especialidad: prof.especialidad,
                };
              }
              return acc;
            }, {})
          ).sort((a, b) => a.especialidad.localeCompare(b.especialidad));

          servicios.unshift({ especialidad: "Todas", servicio: -1 });

          this.servicios = servicios;
          this.servicio = -1;

          this.profesionales = [...this.listaProfesionales];
        } else {
          this.profesionales = [];
          this.servicios = [];
        }
      },
      deep: true,
    },
  },
  methods: {
    buscarProfesionalesInstitucion() {
      const institucionData = {
        idInstitucion: this.idInstitucion,
      };
      let self = this;
      axios
        .get("/PortalPaciente/GetProfInstDispWeb?", {
          params: {
            idInstitucion: institucionData.idInstitucion,
          },
        })
        .then(function (response) {
          self.listaProfesionales = response.data;
        })
        .catch(function (error) {
          self.listaProfesionales = [];
        });
    },
    filtrarProfesionales() {
      if (this.servicio === -1) {
        this.profesionales = [...this.listaProfesionales];
      } else {
        this.profesionales = this.listaProfesionales.filter(
          (prof) => prof.servicio === this.servicio
        );
      }
    },
    seleccionar(item) {
      this.$emit("profesionalSeleccionado", item);
    },
  },
};
</script>
